export const Config = {
  ThemeImageDir: import.meta.env.VITE_THEME_IMG_DIR?.toString(),
  ApiBaseUrl: import.meta.env.VITE_API_BASE?.toString(),
}
